import { screen } from 'components/styles/variables';
import { ReactNode } from 'react';

interface GridRowProps {
  children: ReactNode;
}
export default function GridRow({ children }: GridRowProps): JSX.Element {
  return (
    <div className="dealer-page-grid-row">
      {children}
      <style jsx>{`
        @media (min-width: ${screen.smMin}) {
          .dealer-page-grid-row {
            padding: 0 30px;
          }
        }

        @media (min-width: ${screen.lgMin}) {
          .dealer-page-grid-row {
            padding: 0 110px;
          }
        }
      `}</style>
    </div>
  );
}
